module.exports = __webpack_public_path__ + "static/media/style.c2fc1b85.less";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/List/style.less
// module id = 1050
// module chunks = 0